<div class="container">
  <div *ngIf="pricingFormValues" class="content_price_form" fxLayout fxLayoutWrap fxLayout="row" fxLayoutGap=""
    fxLayout.xs="column" fxLayoutAlign="center center">
    <div class="form" [formGroup]="contactForm" fxFlexOffset="10vw" fxFlex="">

      <div class="pricing-form">
        <mat-form-field class="example-full-width">
          <mat-label>Study Category</mat-label>
          <mat-select formControlName="studyCategory">
            <mat-option *ngFor="let cat of studyCategoryArray" [value]="cat">
              {{cat}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div>
          <mat-form-field class="example-full-width">
            <mat-label>Study title or Study Code Name</mat-label>
            <input  formControlName="studyTitle" matInput/>
          </mat-form-field>
        </div>
        <div fxLayout fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="20px" fxLayoutGap.xs="0">
          <mat-form-field fxFlex class="example-full-width">
            <input formControlName="firstName" matInput placeholder="First Name">
          </mat-form-field>

          <mat-form-field fxFlex class="example-full-width">
            <input formControlName="lastName" matInput placeholder="Last Name">
          </mat-form-field>
        </div>

        <mat-form-field class="example-full-width">
          <input formControlName="workEmail" type="email" email matInput placeholder="Work email">
        </mat-form-field>

        <div fxLayout fxLayout.xs="column" fxLayoutGap="20px" fxLayoutGap.xs="0" fxLayoutAlign="center center">
          <mat-form-field fxFlex class="example-full-width">
            <input formControlName="organization" matInput placeholder="Company Name">
          </mat-form-field>

          <mat-form-field fxFlex class="example-full-width">
            <input formControlName="jobTitle" matInput placeholder="Job title">
          </mat-form-field>
        </div>

        <mat-form-field>
          <mat-label>Size Company</mat-label>
          <mat-select formControlName="sizeCompany">
            <mat-option *ngFor="let size of sizeCompany" [value]="size">
              {{size}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="example-full-width">
          <input formControlName="phone" matInput placeholder="Mobile phone">
        </mat-form-field>


        <div fxLayout fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="20px" fxLayoutGap.xs="0">
          <mat-form-field fxFlex class="example-full-width">
            <input type="text" placeholder="Industry" matInput formControlName="industry" [matAutocomplete]="auto1">
            <mat-autocomplete #auto1="matAutocomplete">
              <mat-option *ngFor="let option of industryFilter | async" [value]="option">
                {{option}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <mat-form-field fxFlex class="example-full-width">
            <input type="text" placeholder="Country" matInput formControlName="country" [matAutocomplete]="auto2">
            <mat-autocomplete #auto2="matAutocomplete">
              <mat-option *ngFor="let option of countryFilter | async" [value]="option">
                {{option}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <div>
          <mat-form-field class="example-full-width">
            <mat-label>Additional Comments <br><small>(please specify any information you think is useful)</small></mat-label>
            <textarea formControlName="comment" matInput></textarea>
          </mat-form-field>
        </div>

        <div class="end-btns">
          <button class="back" mat-raised-button color="alert" (click)="clickedBack()">Back</button>
          <button mat-raised-button class="send" (click)="onSubmit()" color="primary" [disabled]="!contactForm.valid"
            type="submit">Send</button>
        </div>
      </div>

    </div>
    <div class="info" fxFlex>
      <h1>We are almost done.</h1>
      <h2>You chose a formula at <span style="color: #fff; font-size: 20px;"
          *ngIf="price != 'Contact Us' else please"></span>
        <ng-template #please>please </ng-template> <span>{{ price | number:'1.0-2':'fr' }} EUR</span>
      </h2>
    </div>
  </div>
</div>

<div class="err" *ngIf="!pricingFormValues">
  <div class="title alicent">Please start by filling the pricing form</div>
  <div class="subtitle alicent">
    You are:
  </div>
  <div fxLayout="row wrap" fxLayoutAlign="center">
    <mat-radio-group class="radio-gp" [(ngModel)]="orgType">
      <mat-radio-button class="radio-btn" value="2">Commercial law company</mat-radio-button>
      <mat-radio-button class="radio-btn" value="1">Non-profit organization<br><small>Start quote</small></mat-radio-button>
      <mat-radio-button class="radio-btn" value="3">Non-profit organization<br><small>Research partnership agreement application</small></mat-radio-button>
    </mat-radio-group>
  </div>

  <div class="btncontainer buttons">
    <button mat-flat-button class="btn-start-hover color-3" [disabled]="orgType != null ? false : true" (click)="startPricing()">
      Start
    </button>
  </div>
</div>

<app-footer *ngIf="pricingFormValues"></app-footer>